import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { AddButton } from "source/components/framework/Button/AddButton";
import { userParameterCodeShowDocumentPreview } from "source/models/common/webConsts";
import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ApplicationPermissionType, ContentPagePanelType, EventStateFilter, FrontPagePanelSize, ReportSharingType, ReportType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { Translations } from "ui/Scripts/source/models/translations";
import { IdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IdTitleClass, IIdTitleClass } from "ui/Scripts/source/models/common/idTitleClass";
import { AppUtils } from "source/framework/appUtils";
import { IChartItem } from "source/models/chart/chartItem";
import { ISavedChartPanel, SavedChartPanel } from "source/models/chart/savedChartPanel";
import { ICodeTitle } from "source/models/common/codeTitle";
import { IListFilterItem, ListFilterItem } from "source/models/common/listFilterItem";
import { IPagePanel, PagePanel } from "source/models/common/pagePanel";
import { ISavedListFilter } from "source/models/common/savedListFilter";
import { ISavedPrint } from "source/models/common/savedPrint";
import { ITypedOption } from "source/models/common/typedOption";
import { IEventPage } from "source/models/event/eventPage";
import { IEventPageData } from "source/models/event/eventPageData";
import { IReportItem, ReportItem } from "source/models/report/reportItem";
import { getStateChangeAfterChangeActiveReport, getStateChangeAfterChangeActiveSavedReport, handleRemoveSavedReport, ReportItems } from "source/models/report/reportItems";
import { ISavedReport } from "source/models/report/savedReport";
import * as eventService from "source/models/services/eventService";
import { recordLockManager } from "source/models/services/recordLockService";
import * as userService from "source/models/services/userService";
import { IAppSessionState } from "source/models/store/storeTypes";
import { DashboardPanelList } from "source/components/app/DashboardPanelList";
import { HeaderMenuItem, NavigationMenu } from "source/components/app/NavigationMenu";
import { UserMenu } from "source/components/app/UserMenu";
import { ListFilterSaveDialog } from "source/components/framework/Filters/ListFilterSaveDialog/ListFilterSaveDialog";
import { PageContainer } from "source/components/framework/Page/PageContainer";
import { PageContent } from "source/components/framework/Page/PageContent";
import { PageDashboard } from "source/components/framework/Page/PageDashboard";
import { PageListAndReportsContainer } from "source/components/framework/Page/PageListAndReportsContainer";
import { PageReportsContainer } from "source/components/framework/Page/PageReportsContainer";
import { PageTabs } from "source/components/framework/Page/PageTabs";
import { PageTopBar } from "source/components/framework/Page/PageTopBar";
import { IPageNavMenuItem } from "source/components/framework/PageNav/PageNavMenuItems";
import { FilterTabs } from "source/components/framework/PageNavMenuItem/FilterTabs";
import { ReportSettings } from "source/components/framework/ReportSettings";
import { PageNavMenuReportList } from "source/components/report/PageNavMenuItemReportList/PageNavMenuItemReportList";
import { ISaveReportFilters, SaveReportDialog } from "source/components/report/PageNavMenuItemReportList/SaveReportDialog";
import { EventPageFilterDrawer } from "./EventPageFilterDrawer";
import { EventList } from "../EventList";
import { EventPageReportFilterPanel } from "./EventPageReportFilterPanel";
import { EventPageReport } from "./EventPageReport";
import { EventSettingsDialog, EventsSettingsDialogMenuItem } from "../EventSettingsDialog";
import { abortManager } from "source/models/services/tokenService";
import { IEventListState, setEventListDefaultFilter } from "source/models/store/event";
import { IFrontToDoItem } from "source/models/front/frontToDoItem";
import { TDefaultListFilter } from "source/models/common/defaultListFilter";
import { getEventFiltersFromIdColorTitle, getEventFiltersFromNumberTitle, getEventGeneralFilterFromFilterState, getEventIdTitleNodeFilters, getEventPageDynamicTimeFilters, getEventTypeFilters, getFilterStatePropsFromEventGeneralFilter, IEventGeneralFilter, IEventPageFilterState } from "./EventPageUtils";
import { EventPageDashboardChart } from "./EventPageDashboardChart";
import { ISharedPanel } from "source/models/panel/sharedPanel";

/* eslint-disable no-unused-vars */
export const enum EventPageViewType {
    Events = "0",
    Reports = "1",
    Dashboard = "2",
}
/* eslint-enable no-unused-vars */

// EventPage
export interface IEventPageOwnProps {
}

export interface IEventPageStateProps {
    appState: IAppSessionState;
    dataId: number;
    eventPage: IEventPage;
    list: IEventListState;
}

export interface IEventPageDispatchProps {
    onGetEventPage: () => void;
    onLogout: () => void;
    onSetCulture: (culture: string) => void;
    onRefreshSessionState: () => void;
    onSaveUserParameters: (parameters: ITypedOption[]) => void;
}

export interface IEventPagePathProps {
    page: string;
}

type EventPageProp = IEventPageOwnProps & IEventPageStateProps & IEventPageDispatchProps & RouteComponentProps<IEventPagePathProps>;

interface IEventPageState extends IEventPageFilterState {
    initialized: boolean;
    listAddRecord: boolean;
    viewTypes: IIdTitleClass[];
    units: IIdTitleNode[];
    states: IIdTitle[];
    urgencyClasses: IdColorTitle[];
    partners: IIdTitle[];
    creators: IIdTitle[];
    handlers: IIdTitle[];
    observers: IIdTitle[];
    eventTypes: IIdTitleNode[];
    eventTypeBs: IIdTitleNode[];
    eventTypeCs: IIdTitleNode[];
    dynamicTimeFilters: IIdTitle[];

    showNavPanel: boolean;
    activeViewType: EventPageViewType;
    activeCompanyId: string;

    sortColumn: string;
    sortOrderIsAsc: boolean;
    eventSettingsActions: IPageNavMenuItem[];
    // Filters
    listFilterIsSet: boolean;
    showEventFilterDialog: boolean;
    eventFilterDialogFilter: IListFilterItem;
    filters: IListFilterItem[];
    savedFilters: IListFilterItem[];
    activeFilterId: string;
    activeSavedFilterId: string;
    showListFilterSaveDialog: boolean;
    listFilterSaveDialogFilter: IListFilterItem;
    listFilterSaveDialogGeneralFilter: any;
    listFilterSaveDialogReservedNames: string[];
    listFilterSaveDialogOnGetGeneralFilter: () => any;
    // Settings
    showSettingsDialog: boolean;
    settingsDialogCompanyId: string;
    // Permissions
    dataId: number;
    // Reports
    loadingReports: boolean;
    reports: IReportItem[];
    savedReports: IReportItem[];
    reportChartItems: IChartItem[];
    activeReportId: string;
    activeSavedReportId: string;
    reportFilterReport: IReportItem;
    showReportSaveDialog: boolean;
    reportSaveDialogReport: IReportItem;
    reportSaveDialogGeneralFilter: any;
    reportSaveDialogReservedNames: string[];
    reportSaveDialogOnGetReportSaveFilters: () => ISaveReportFilters;
    // Prints
    userPrints: ISavedPrint[];
    printableFields: IIdTitleNode[];
    showEventPrintDialog: boolean;
    eventPrintDialogPrint: ISavedPrint;
    eventPrintDialogReservedNames: string[];
    // Dashboard
    showDashBoardNavPanel: boolean;
    dashBoardPanels: IPagePanel[];
    showDashBoardChartPanel: boolean;
    dashBoardChartPanelFilter: IEventPageFilterState;
    dashBoardChartPanelVisible: boolean;
    dashBoardChartPanelPanelSize: number;
    dashBoardChartPanelChartItems: IChartItem[];
    dashBoardChartPanelChartPanel: ISavedChartPanel;
    dashBoardChartPanelReservedChartNames: string[];
    // Preview
    showDocumentPreview: boolean;
}

export class EventPage extends React.Component<EventPageProp, IEventPageState> {
    _isMounted: boolean;

    static getViewTypes = (): IIdTitleClass[] => {
        const result: IIdTitleClass[] = [];
        result.push(IdTitleClass.createIdTitleClass(EventPageViewType.Events, Translations.Events, "list2"));
        result.push(IdTitleClass.createIdTitleClass(EventPageViewType.Reports, Translations.Reports, "report"));
        result.push(IdTitleClass.createIdTitleClass(EventPageViewType.Dashboard, Translations.FrontPage, "home"));
        return result;
    };
    
    getIdTitleFilters = (items: IIdTitle[]): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(Base.emptyGuid, "'" + Translations.All + "'"));
        return result.concat(items);
    };
    
    getFiltersFromCodeTitle = (items: ICodeTitle[], allId: string = ""): IIdTitle[] => {
        const result: IIdTitle[] = [];
        result.push(IdTitle.createIdTitle(allId, "'" + Translations.All + "'"));
        return result.concat(items.map(i => IdTitle.createIdTitle(i.code, i.title)));
    };

    getHtlmlReportItems = (): IReportItem[] => {
        const result: IReportItem[] = [];
        return result;
    };
    
    getFilters = (): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        result.push(ListFilterItem.createListFilterItem(Translations.Events, Translations.Events,
            getEventGeneralFilterFromFilterState(null), "state", true));
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getSavedFilters = (props: EventPageProp): IListFilterItem[] => {
        const result: IListFilterItem[] = [];
        if (!props || !props.eventPage) return result;
        for (const companyFilter of props.eventPage.companyFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(companyFilter, true));
        }
        for (const userFilter of props.eventPage.userFilters) {
            result.push(ListFilterItem.createListFilterItemFromSavedListFilter(userFilter, false));
        }
        ListFilterItem.sortListFilterItems(result);
        return result;
    };

    getListFilterIsSet = (state: IEventPageState): boolean => {
        return EventPageFilterDrawer.filterIsSet(state, state);
    };

    getEventSettingsActions = (pageData: IEventPageData): IPageNavMenuItem[] => {
        const sessionState = this.props.appState.state;
        const result: IPageNavMenuItem[] = [];
        if (pageData?.canEditAllModuleProperties) {
            result.push({ id: EventsSettingsDialogMenuItem.Units, title: Translations.Units });
            result.push({ id: EventsSettingsDialogMenuItem.Permissions, title: Translations.Permissions });
            result.push({ id: EventsSettingsDialogMenuItem.Settings, title: Translations.Settings });
            result.push({ id: EventsSettingsDialogMenuItem.DefaultEventHandlersAndNotifiedPersons, title: Translations.DefaultEventHandlersAndNotifiedPersons });
        }
        if (pageData?.canEditModuleProperties) {
            result.push({ id: EventsSettingsDialogMenuItem.EventUrgencyClasses, title: Translations.EventUrgencyClasses });
            result.push({ id: EventsSettingsDialogMenuItem.EventTypes, title: Translations.EventTypes });
            result.push({ id: EventsSettingsDialogMenuItem.EventTypeBs, title: Translations.EventTypeBs });
            result.push({ id: EventsSettingsDialogMenuItem.EventTypeCs, title: Translations.EventTypeCs });
        }
        if (pageData?.canEditAllModuleProperties && (pageData?.hasExplicitEventPartners || sessionState.isSuperAdmin)) {
            result.push({ id: EventsSettingsDialogMenuItem.EventPartners, title: Translations.EventPartners });
        }
        if (sessionState.isSuperAdmin) {
            result.push({ id: EventsSettingsDialogMenuItem.DefaultSettings, title: Translations.DefaultSettings });
            result.push({ id: EventsSettingsDialogMenuItem.DefaultEventUrgencyClasses, title: Translations.DefaultEventUrgencyClasses });
            result.push({ id: EventsSettingsDialogMenuItem.DefaultEventTypes, title: Translations.DefaultEventTypes });
        }
        return result;
    };

    getDefaultEventPageViewType = (props: EventPageProp): EventPageViewType => {
        if (!props.match.params.page) return EventPageViewType.Dashboard;
        if (props.match.params.page.equalIgnoreCase("list")) return EventPageViewType.Events;
        if (props.match.params.page.equalIgnoreCase("reports")) return EventPageViewType.Reports;
        return EventPageViewType.Dashboard;
    };

    constructor(props: EventPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
        const sessionState = props.appState.state;
        const filters = this.getFilters();
        const filter = (props.list.defaultFilter?.filterId
            ? filters.find(i => i.id === props.list.defaultFilter.filterId)
            : filters[0]) ?? filters[0];
        const intialFilter = new ListFilterItem(filter);
        if (props.list.defaultFilter?.generalFilter) {
            intialFilter.generalFilter = { ...intialFilter.generalFilter, ...props.list.defaultFilter.generalFilter };
        }
        const filterProps = ListFilterItem.getFilterProps(intialFilter, "", true, getFilterStatePropsFromEventGeneralFilter);
        const dynamicTimeFilters = getEventPageDynamicTimeFilters(true);
        const state = {
            ...filterProps,
            initialized: !!props.eventPage,
            showNavPanel: sessionState.getShowPageNavigation(),
            activeViewType: this.getDefaultEventPageViewType(props),
            activeCompanyId: sessionState.companyId,
            listAddRecord: false,
            viewTypes: EventPage.getViewTypes(),
            units: getEventIdTitleNodeFilters(props.eventPage ? props.eventPage.units : []),
            states: getEventFiltersFromNumberTitle(props.eventPage ? props.eventPage.states : []),
            urgencyClasses: getEventFiltersFromIdColorTitle(props.eventPage ? props.eventPage.urgencyClasses : []),
            eventTypes: getEventTypeFilters(props.eventPage ? props.eventPage.eventTypes : []),
            eventTypeBs: getEventTypeFilters(props.eventPage ? props.eventPage.eventTypeBs : []),
            eventTypeCs: getEventTypeFilters(props.eventPage ? props.eventPage.eventTypeCs : []),
            partners: this.getIdTitleFilters(props.eventPage ? props.eventPage.partners : []),
            creators: this.getFiltersFromCodeTitle(props.eventPage ? props.eventPage.creators : []),
            handlers: this.getFiltersFromCodeTitle(props.eventPage ? props.eventPage.handlers : []),
            observers: this.getFiltersFromCodeTitle(props.eventPage ? props.eventPage.observers : [], Base.emptyGuid),
            dynamicTimeFilters,
            selectedStartDate: 0,
            selectedEndDate: 0,
            selectedDynamicTimeFilterId: dynamicTimeFilters[0].id,
            eventFilterActions: [],
            eventSettingsActions: this.getEventSettingsActions(props.eventPage),
            // Filters
            listFilterIsSet: false,
            activeFilterId: filter.id,
            activeSavedFilterId: "",
            filters,
            savedFilters: this.getSavedFilters(props),
            showEventFilterDialog: false,
            eventFilterDialogFilter: null,
            showListFilterSaveDialog: false,
            listFilterSaveDialogFilter: null,
            listFilterSaveDialogGeneralFilter: null,
            listFilterSaveDialogReservedNames: [],
            listFilterSaveDialogOnGetGeneralFilter: null,
            // Settings
            showSettingsDialog: false,
            settingsDialogCompanyId: "",
            // Permissions
            dataId: props.dataId,
            // Reports
            loadingReports: true,
            reports: this.getHtlmlReportItems(),
            savedReports: [],
            reportChartItems: [],
            activeReportId: "",
            activeSavedReportId: "",
            reportFilterReport: null,
            showReportSaveDialog: false,
            reportSaveDialogReport: null,
            reportSaveDialogGeneralFilter: null,
            reportSaveDialogReservedNames: [],
            reportSaveDialogOnGetReportSaveFilters: null,
            // Prints
            userPrints: props.eventPage ? props.eventPage.userPrints : [],
            printableFields: props.eventPage ? props.eventPage.printableFields : [],
            showEventPrintDialog: false,
            eventPrintDialogPrint: null,
            eventPrintDialogReservedNames: [],
            // Dashboard
            showDashBoardNavPanel: false,
            dashBoardPanels: [],
            showDashBoardChartPanel: false,
            dashBoardChartPanelFilter: null,
            dashBoardChartPanelVisible: false,
            dashBoardChartPanelPanelSize: FrontPagePanelSize.OneXOne,
            dashBoardChartPanelChartItems: [],
            dashBoardChartPanelChartPanel: null,
            dashBoardChartPanelReservedChartNames: [],
            // Preview
            showDocumentPreview: false,
        };
        this.state = {
            ...state,
            dashBoardPanels: this.getDashBoardPanels(state.reportChartItems),
            listFilterIsSet: this.getListFilterIsSet(state)
        };
        setEventListDefaultFilter(null);
    }

    getDashBoardPanels = (chartItems: IChartItem[]): IPagePanel[] => {
        const props = this.props;
        const result = (props.eventPage ? props.eventPage.panels : []);
        const chartPanels = props.eventPage ? props.eventPage.chartPanels : [];
        const newChartPanels: ISavedChartPanel[] = [];
        for (const chartPanel of chartPanels) {
            const chartItem = chartItems.find(i => chartPanel.reportId === i.reportName);
            if (chartPanel.id === chartPanel.reportId) {
                chartPanel.reportTitle = chartItem
                    ? chartItem.reportDescription
                    : chartPanel.id;
            } else {
                chartPanel.reportTitle = chartPanel.id;
            }
            chartPanel.disabled = !chartItem;
            newChartPanels.push(chartPanel);
        }
        return PagePanel.sortPagePanels(result.concat(newChartPanels));
    };

    setGeneralFilterToDefaultReports = (state: { reports: IReportItem[] }) => {
        const dynamicTimeFilterId = 1; //30 days
        for (const report of state.reports) {
            report.generalFilter = { dynamicTimeFilterId };
        }
    };

    getReports = async (companyId: string) => {
        const state = this.state;
        const newState = await ReportItems.getReportsState(companyId, state.activeReportId, state.activeSavedReportId, this.getHtlmlReportItems(), eventService.getEventPageReportItems,
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: true });
            },
            () => {
                if (!this._isMounted) return;
                this.setState({ loadingReports: false });
            });
        if (!this._isMounted || !newState) return;
        this.setGeneralFilterToDefaultReports(newState);
        this.setState({ ...newState, dashBoardPanels: this.getDashBoardPanels(newState.reportChartItems) });
    };

    componentDidMount(): void {
        const props = this.props;
        const sessionState = props.appState.state;
        recordLockManager.unlockAll(sessionState.companyId, sessionState.code);
        props.onGetEventPage();
        this.getReports(sessionState.companyId);
        this._isMounted = true;
    }

    componentDidUpdate(prevProps: EventPageProp, prevState: IEventPageState): void {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        //companyIds change?
        const prevCompanyIds = (prevProps.eventPage ? prevProps.eventPage.companies.map(i => i.id) : []).join(",");
        const companyIds = (props.eventPage ? props.eventPage.companies.map(i => i.id) : []).join(",");
        const prevCompanyId = prevProps.eventPage && prevProps.eventPage.companies.length > 0
            ? prevProps.eventPage.companies[0].id
            : Base.emptyGuid;
        const companyId = props.eventPage && props.eventPage.companies.length > 0
            ? props.eventPage.companies[0].id
            : Base.emptyGuid;
        //permissions change?
        const prevCanEditModuleProperties = prevProps.eventPage?.canEditModuleProperties ?? false;
        const canEditModuleProperties = props.eventPage?.canEditModuleProperties ?? false;
        const prevCanEditAllModuleProperties = prevProps.eventPage?.canEditAllModuleProperties ?? false;
        const canEditAllModuleProperties = props.eventPage?.canEditAllModuleProperties ?? false;
        //units change?
        const unitsData = props.eventPage ? props.eventPage.units : [];
        const equalUnits = Base.equalStrArrays(prevProps.eventPage ? prevProps.eventPage.units.map(i => i.id) : [], unitsData.map(i => i.id));
        const units = getEventIdTitleNodeFilters(unitsData);
        const prevStatesHash = prevProps.eventPage ? IdTitle.getHash(prevProps.eventPage.states.map(i => IdTitle.createIdTitle(i.number.toString(10), i.title))) : "";
        //states change?
        const statesData = props.eventPage ? props.eventPage.states : [];
        const statesHash = IdTitle.getHash(statesData.map(i => IdTitle.createIdTitle(i.number.toString(10), i.title)));
        const states = getEventFiltersFromNumberTitle(statesData);
        //urgencyClasses change?
        const urgencyClassData = props.eventPage ? props.eventPage.urgencyClasses : [];
        const equalUrgencyClasses = Base.equalStrArrays(prevProps.eventPage ? prevProps.eventPage.urgencyClasses.map(i => i.id) : [], urgencyClassData.map(i => i.id));
        const urgencyClasses = getEventFiltersFromIdColorTitle(urgencyClassData);
        //eventTypes change?
        const eventTypesData = props.eventPage ? props.eventPage.eventTypes : [];
        const equalEventTypes = IdTitleNode.equalIdsInArrays(prevProps.eventPage?.eventTypes ?? [], eventTypesData);
        const eventTypes = getEventTypeFilters(eventTypesData);
        //eventTypeBs change?
        const eventTypeBsData = props.eventPage ? props.eventPage.eventTypeBs : [];
        const equalEventTypeBs = IdTitleNode.equalIdsInArrays(prevProps.eventPage?.eventTypeBs ?? [], eventTypeBsData);
        const eventTypeBs = getEventTypeFilters(eventTypeBsData);
        //eventTypeCs change?
        const eventTypeCsData = props.eventPage ? props.eventPage.eventTypeCs : [];
        const equalEventTypeCs = IdTitleNode.equalIdsInArrays(prevProps.eventPage?.eventTypeCs ?? [], eventTypeCsData);
        const eventTypeCs = getEventTypeFilters(eventTypeCsData);
        const prevPartnersHash = prevProps.eventPage ? IdTitle.getHash(prevProps.eventPage.partners) : "";
        //partners change?
        const partnersData = props.eventPage ? props.eventPage.partners : [];
        const partnersHash = IdTitle.getHash(partnersData);
        const partners = this.getIdTitleFilters(partnersData);
        //creators change?
        const prevCreatorsHash = prevProps.eventPage ? IdTitle.getHash(prevProps.eventPage.creators.map(i => IdTitle.createIdTitle(i.code, i.title))) : "";
        const creatorsData = props.eventPage ? props.eventPage.creators : [];
        const creatorsHash = IdTitle.getHash(creatorsData.map(i => IdTitle.createIdTitle(i.code, i.title)));
        const creators = this.getFiltersFromCodeTitle(creatorsData);
        const prevHandlersHash = prevProps.eventPage ? IdTitle.getHash(prevProps.eventPage.handlers.map(i => IdTitle.createIdTitle(i.code, i.title))) : "";
        //handlers change?
        const handlersData = props.eventPage ? props.eventPage.handlers : [];
        const handlersHash = IdTitle.getHash(handlersData.map(i => IdTitle.createIdTitle(i.code, i.title)));
        const handlers = this.getFiltersFromCodeTitle(handlersData);
        const prevObserversHash = prevProps.eventPage ? IdTitle.getHash(prevProps.eventPage.observers.map(i => IdTitle.createIdTitle(i.code, i.title))) : "";
        //observers change?
        const observersData = props.eventPage ? props.eventPage.observers : [];
        const observersHash = IdTitle.getHash(observersData.map(i => IdTitle.createIdTitle(i.code, i.title)));
        const observers = this.getFiltersFromCodeTitle(observersData, Base.emptyGuid);
        //props change?
        if (prevProps.dataId === props.dataId && prevCompanyId === companyId && prevCanEditModuleProperties === canEditModuleProperties &&
            prevCanEditAllModuleProperties === canEditAllModuleProperties && prevCompanyIds === companyIds && equalUnits &&
            prevStatesHash === statesHash && equalUrgencyClasses && equalEventTypes && equalEventTypeBs &&
            equalEventTypeCs && prevPartnersHash === partnersHash && prevCreatorsHash === creatorsHash &&
            prevHandlersHash === handlersHash && prevObserversHash === observersHash) return;
        const savedFilters = this.getSavedFilters(props);
        const selectedUnitIds = equalUnits ? state.selectedUnitIds : [Base.emptyGuid];
        const selectedStateIds = prevStatesHash === statesHash ? state.selectedStateIds : [EventStateFilter.All.toString(10)];
        const selectedUrgencyClassIds = equalUrgencyClasses ? state.selectedUrgencyClassIds : [Base.emptyGuid];
        const selectedEventTypeIds = equalEventTypes ? state.selectedEventTypeIds : [Base.emptyGuid];
        const selectedEventTypeBIds = equalEventTypeBs ? state.selectedEventTypeBIds : [Base.emptyGuid];
        const selectedEventTypeCIds = equalEventTypeCs ? state.selectedEventTypeCIds : [Base.emptyGuid];
        const selectedPartnerCompanyIds = prevPartnersHash === partnersHash ? state.selectedPartnerCompanyIds : [Base.emptyGuid];
        const selectedCreateUserCodes = prevCreatorsHash === creatorsHash ? state.selectedCreateUserCodes : [""];
        const selectedHandlerUserCodes = prevHandlersHash === handlersHash ? state.selectedHandlerUserCodes : [""];
        const selectedObservers = prevObserversHash === observersHash ? state.selectedObservers : [Base.emptyGuid];
        const activeSavedFilterId = savedFilters.find(i => i.id === state.activeSavedFilterId)
            ? state.activeSavedFilterId
            : "";
        const stateChange = {
            dataId: props.dataId,
            initialized: !!props.eventPage,
            dashBoardPanels: this.getDashBoardPanels(state.reportChartItems),
            showNavPanel: state.initialized ? state.showNavPanel : sessionState.getShowPageNavigation(),
            activeViewType: companyId !== sessionState.companyId
                ? EventPageViewType.Events
                : state.activeViewType,
            activeCompanyId: companyId,
            units,
            states,
            urgencyClasses,
            eventTypes,
            eventTypeBs,
            eventTypeCs,
            partners,
            creators,
            handlers,
            observers,
            userPrints: props.eventPage ? props.eventPage.userPrints : [],
            printableFields: props.eventPage ? props.eventPage.printableFields : [],
            selectedUnitIds,
            selectedStateIds,
            selectedUrgencyClassIds,
            selectedEventTypeIds,
            selectedEventTypeBIds,
            selectedEventTypeCIds,
            selectedPartnerCompanyIds,
            selectedCreateUserCodes,
            selectedHandlerUserCodes,
            selectedObservers,
            savedFilters,
            activeSavedFilterId,
            eventSettingsActions: this.getEventSettingsActions(props.eventPage),
            showDocumentPreview: props.eventPage?.showDocumentPreview ?? state.showDocumentPreview
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    }

    componentWillUnmount(): void {
        this._isMounted = false;
    }

    handleToggleShowNavPanel = () => {
        this.setState({ showNavPanel: !this.state.showNavPanel });
    };

    // #region Saved Filter
    getFilterPropsWithState = (listItemFilter: IListFilterItem, additionalGeneralFilter: any = null): IEventPageFilterState & { sortColumn: string, sortOrderIsAsc: boolean } => {
        const state = this.state;
        let result = {
            selectedStartDate: state.selectedStartDate,
            selectedEndDate: state.selectedEndDate,
            selectedUnitIds: state.selectedUnitIds,
            selectedStateIds: state.selectedStateIds,
            selectedUrgencyClassIds: state.selectedUrgencyClassIds,
            selectedEventTypeIds: state.selectedEventTypeIds,
            selectedEventTypeBIds: state.selectedEventTypeBIds,
            selectedEventTypeCIds: state.selectedEventTypeCIds,
            selectedPartnerCompanyIds: state.selectedPartnerCompanyIds,
            selectedCreateUserCodes: state.selectedCreateUserCodes,
            selectedHandlerUserCodes: state.selectedHandlerUserCodes,
            selectedObservers: state.selectedObservers,
            selectedDynamicTimeFilterId: state.selectedDynamicTimeFilterId,
            sortColumn: state.sortColumn,
            sortOrderIsAsc: state.sortOrderIsAsc
        };
        if (listItemFilter) {
            const filter = new ListFilterItem(listItemFilter);
            if (additionalGeneralFilter) {
                filter.generalFilter = { ...filter.generalFilter, ...additionalGeneralFilter };
            }
            result = ListFilterItem.getFilterProps(filter, result.sortColumn, result.sortOrderIsAsc, getFilterStatePropsFromEventGeneralFilter);
        }
        return result;
    };

    handleChangeActiveCompanyId = async (companyId: string) => {
        if (this.state.activeCompanyId === companyId) return;
        await this.handleRefreshPageData(companyId);
        this.getReports(companyId);
    };

    getStateChangeAfterChangeActiveFilter = (activeFilterId: string, additionalGeneralFilter: any = null): any => {
        const state = this.state;
        const filter = state.filters.find(i => i.id === activeFilterId);
        if (!filter) return;
        const filterProps = this.getFilterPropsWithState(filter, additionalGeneralFilter);
        const activeSavedFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId: "",
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveFilter = (activeFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveFilter(activeFilterId));
    };

    getStateChangeAfterChangeActiveSavedFilter = (activeSavedFilterId: string): any => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === activeSavedFilterId);
        if (!savedFilter) return;
        const filterProps = this.getFilterPropsWithState(savedFilter);
        const activeFilterId = "";
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId };
        return {
            ...filterProps,
            activeFilterId,
            activeSavedFilterId,
            listFilterIsSet: this.getListFilterIsSet(newState)
        };
    };

    handleChangeActiveSavedFilter = (activeSavedFilterId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedFilter(activeSavedFilterId));
    };

    handleRemoveSavedFilter = async (savedFilterId: string) => {
        const state = this.state;
        const savedFilter = state.savedFilters.find(i => i.id === savedFilterId);
        if (!savedFilter) return;
        const result = await ListFilterSaveDialog.removeListFilterFromDb(state.savedFilters, state.activeCompanyId, savedFilterId, savedFilter.isShared, ApplicationPermissionType.Event);
        if (!result) return;
        const savedFilters = state.savedFilters.filter(i => i.id !== savedFilterId);
        let activeFilterId = "";
        let activeSavedFilterId = "";
        let newfilter: IListFilterItem = null;
        if (savedFilters.length > 0) {
            newfilter = savedFilters[0];
            activeSavedFilterId = newfilter.id;
        } else if (state.filters.length > 0) {
            newfilter = state.filters[0];
            activeFilterId = newfilter.id;
        }
        const filterProps = this.getFilterPropsWithState(newfilter);
        const newState = { ...state, ...filterProps, activeFilterId, activeSavedFilterId, savedFilters };
        this.setState({
            ...filterProps,
            showEventFilterDialog: false,
            activeFilterId,
            activeSavedFilterId,
            savedFilters,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    handleFilterSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        this.setState({
            sortColumn,
            sortOrderIsAsc,
        });
    };

    updateFiltersAfterSave = (orgFilterId: string, savedListFilter: ISavedListFilter, isShared: boolean) => {
        if (!savedListFilter) return;
        const state = this.state;
        const savedFilters = state.savedFilters.filter(i => i.id !== orgFilterId || i.isShared !== isShared);
        const filter = ListFilterItem.createListFilterItemFromSavedListFilter(savedListFilter, isShared);
        savedFilters.push(filter);
        ListFilterItem.sortListFilterItems(savedFilters);
        this.setState({
            showListFilterSaveDialog: false,
            savedFilters,
            activeFilterId: "",
            activeSavedFilterId: savedListFilter.id,
            eventFilterDialogFilter: filter
        });
    };

    getActiveFilter = (): IListFilterItem => {
        const state = this.state;
        return state.activeFilterId
            ? state.filters.find(i => i.id === state.activeFilterId)
            : state.savedFilters.find(i => i.id === state.activeSavedFilterId);
    };

    handleSaveListFilter = async (saveAs: boolean, onGetGeneralFilter: () => any) => {
        const state = this.state;
        const filter = this.getActiveFilter();
        if (!filter) return;
        if (!saveAs) {
            const savedListFilter = await ListFilterSaveDialog.saveListFilterToDb(filter, getEventGeneralFilterFromFilterState(state), state.sortColumn, state.sortOrderIsAsc, state.activeCompanyId, ApplicationPermissionType.Event);
            this.updateFiltersAfterSave(filter.id, savedListFilter, filter.isShared);
        } else {
            this.setState({
                showListFilterSaveDialog: true,
                listFilterSaveDialogFilter: filter,
                listFilterSaveDialogReservedNames: state.savedFilters.map(i => i.id).concat(state.filters.map(i => i.title)),
                listFilterSaveDialogGeneralFilter: getEventGeneralFilterFromFilterState(state),
                listFilterSaveDialogOnGetGeneralFilter: onGetGeneralFilter
            });
        }
    };

    handleSaveListFilterDialogOk = (savedListFilter: ISavedListFilter, isShared: boolean) => {
        this.updateFiltersAfterSave("", savedListFilter, isShared);
    };

    handleSaveListFilterDialogCancel = () => {
        this.setState({
            showListFilterSaveDialog: false
        });
    };
    // #endregion Saved Filter

    // #region Record Filter
    handleOpenEventFilterDialog = () => {
        const filter = this.getActiveFilter();
        if (!filter) return;
        this.setState({
            showEventFilterDialog: true,
            eventFilterDialogFilter: filter
        });
    };

    onEventFilterDialogOk = (closeDialog: boolean, filterState: IEventPageFilterState): IEventGeneralFilter => {
        const newState = {
            ...this.state,
            ...filterState
        };
        this.setState({
            showEventFilterDialog: !closeDialog,
            ...filterState,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return getEventGeneralFilterFromFilterState(newState);
    };
    
    onEventFilterDialogCancel = () => {
        this.setState({ showEventFilterDialog: false });
    };
    // #endregion Record Filter

    // #region Report
    getStateChangeAfterChangeActiveReport = (activeReportId: string) => {
        return getStateChangeAfterChangeActiveReport(
            this.state,
            getFilterStatePropsFromEventGeneralFilter,
            this.getListFilterIsSet,
            activeReportId
        );
    };
    
    handleChangeActiveReport = (activeReportId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveReport(activeReportId));
    };

    getStateChangeAfterChangeActiveSavedReport = (activeSavedReportId: string): any => {
        return getStateChangeAfterChangeActiveSavedReport(
            this.state,
            getFilterStatePropsFromEventGeneralFilter,
            this.getListFilterIsSet,
            activeSavedReportId);
    };

    handleChangeActiveSavedReport = (activeSavedReportId: string) => {
        this.setState(this.getStateChangeAfterChangeActiveSavedReport(activeSavedReportId));
    };

    handleRemoveSavedReport = async (reportId: string) => {
        this.setState(await handleRemoveSavedReport(
            this.state,
            getFilterStatePropsFromEventGeneralFilter,
            this.getListFilterIsSet,
            ApplicationPermissionType.Event,
            SaveReportDialog.removeReportFromDb,
            reportId
        ));
    };
    // #endregion Report

    // #region Saved Print
    handleUserPrintsModified = (userPrints: ISavedPrint[]) => {
        this.setState({
            userPrints
        });
    };
    // #endregion Saved Print

    setActiveViewType = (itemId: EventPageViewType, listAddRecord: boolean, activeFilterId: string = null, additionalGeneralFilter: any = null) => {
        const state = this.state;
        //To reset filter when filter/report is activated
        let newState = {};
        if (itemId === EventPageViewType.Reports) {
            if (state.activeReportId) {
                newState = this.getStateChangeAfterChangeActiveReport(state.activeReportId);
            } else if (state.activeSavedReportId) {
                newState = this.getStateChangeAfterChangeActiveSavedReport(state.activeSavedReportId);
            }
        } else if (itemId === EventPageViewType.Events) {
            if (activeFilterId ?? state.activeFilterId) {
                newState = this.getStateChangeAfterChangeActiveFilter(activeFilterId ?? state.activeFilterId, additionalGeneralFilter);
            } else if (state.activeSavedFilterId) {
                newState = this.getStateChangeAfterChangeActiveSavedFilter(state.activeSavedFilterId);
            }
        }
        this.setState({
            ...newState,
            activeViewType: itemId,
            listAddRecord
        });
    };

    handleSetActiveViewType = (itemId: EventPageViewType, activeFilterId: string = null, additionalGeneralFilter: any = null) => {
        this.setActiveViewType(itemId, false, activeFilterId, additionalGeneralFilter);
    };

    handleAddEvent = () => {
        this.setActiveViewType(EventPageViewType.Events, true);
    };

    // #region Settings
    handleOpenSettings = async (defaultSettings: boolean) => {
        this.setState({
            showSettingsDialog: true,
            settingsDialogCompanyId: defaultSettings ? "" : this.state.activeCompanyId
        });
    };

    handleSettingsDialogOk = async (refreshView: boolean) => {
        this.setState({
            showSettingsDialog: false,
            dataId: this.state.dataId + 1
        });
        if (!refreshView) return;
        await this.handleRefreshPageData(this.state.activeCompanyId);
    };
    // #endregion Settings

    handleShowDetailsPanel = (showDocumentPreview) => {
        this.setState({ showDocumentPreview });
        AppUtils.callService(() => userService.saveUserParameter(userParameterCodeShowDocumentPreview, showDocumentPreview ? "TRUE" : "FALSE"), false, true);
    };

    handleRefreshPageData = async (companyId: string) => {
        const state = this.state;
        const eventPageData = await AppUtils.callService(() => eventService.getEventPageData(companyId), false);
        //Units and unit filter ids
        const units = getEventIdTitleNodeFilters(eventPageData.units);
        let selectedUnitIds = state.selectedUnitIds.slice(0);
        if (selectedUnitIds.length > 0 && selectedUnitIds[0] !== Base.emptyGuid) {
            const selectedUnits = IdTitleNode.getByIds(units, selectedUnitIds);
            selectedUnitIds = selectedUnits.map(i => i.id);
        }
        //States and State filter ids
        const states = getEventFiltersFromNumberTitle(eventPageData.states);
        let selectedStateIds = state.selectedStateIds.slice(0);
        if (selectedStateIds.length > 0 && selectedStateIds[0] !== EventStateFilter.All.toString(10)) {
            const stateIds = states.map(i => i.id);
            selectedStateIds = selectedStateIds.filter(i => stateIds.indexOf(i) > -1);
        }
        //EventTypes and event type filter ids
        const eventTypes = getEventTypeFilters(eventPageData.eventTypes);
        let selectedEventTypeIds = state.selectedEventTypeIds.slice(0);
        if (selectedEventTypeIds.length > 0 && selectedEventTypeIds[0] !== Base.emptyGuid) {
            const selectedEventTypes = IdTitleNode.getByIds(eventTypes, selectedEventTypeIds);
            selectedEventTypeIds = selectedEventTypes.map(i => i.id);
        }
        //EventTypeBs and event type b filter ids
        const eventTypeBs = getEventTypeFilters(eventPageData.eventTypeBs);
        let selectedEventTypeBIds = state.selectedEventTypeBIds.slice(0);
        if (selectedEventTypeBIds.length > 0 && selectedEventTypeBIds[0] !== Base.emptyGuid) {
            const selectedEventTypeBs = IdTitleNode.getByIds(eventTypeBs, selectedEventTypeBIds);
            selectedEventTypeBIds = selectedEventTypeBs.map(i => i.id);
        }
        //EventTypeCs and event type c filter ids
        const eventTypeCs = getEventTypeFilters(eventPageData.eventTypeCs);
        let selectedEventTypeCIds = state.selectedEventTypeCIds.slice(0);
        if (selectedEventTypeCIds.length > 0 && selectedEventTypeCIds[0] !== Base.emptyGuid) {
            const selectedEventTypeCs = IdTitleNode.getByIds(eventTypeCs, selectedEventTypeCIds);
            selectedEventTypeCIds = selectedEventTypeCs.map(i => i.id);
        }
        //Partners and Partner filter ids
        const partners = this.getIdTitleFilters(eventPageData.partners);
        let selectedPartnerCompanyIds = state.selectedPartnerCompanyIds.slice(0);
        if (selectedPartnerCompanyIds.length > 0 && selectedPartnerCompanyIds[0] !== Base.emptyGuid) {
            const partnerIds = partners.map(i => i.id);
            selectedPartnerCompanyIds = selectedPartnerCompanyIds.filter(i => partnerIds.indexOf(i) > -1);
        }
        //Creators and Creator filter user codes
        const creators = this.getFiltersFromCodeTitle(eventPageData.creators);
        let selectedCreateUserCodes = state.selectedCreateUserCodes.slice(0);
        if (selectedCreateUserCodes.length > 0 && selectedCreateUserCodes[0] !== "") {
            const creatorUserCodes = creators.map(i => i.id);
            selectedCreateUserCodes = selectedCreateUserCodes.filter(i => creatorUserCodes.indexOf(i) > -1);
        }
        //Handlers and Handler filter user codes
        const handlers = this.getFiltersFromCodeTitle(eventPageData.handlers);
        let selectedHandlerUserCodes = state.selectedHandlerUserCodes.slice(0);
        if (selectedHandlerUserCodes.length > 0 && selectedHandlerUserCodes[0] !== "") {
            const handlerUserCodes = handlers.map(i => i.id);
            selectedHandlerUserCodes = selectedHandlerUserCodes.filter(i => handlerUserCodes.indexOf(i) > -1);
        }
        //Observers and Observer filter user codes
        const observers = this.getFiltersFromCodeTitle(eventPageData.observers, Base.emptyGuid);
        let selectedObservers = state.selectedObservers.slice(0);
        if (selectedObservers.length > 0 && selectedObservers[0] !== Base.emptyGuid) {
            const observersNames = observers.map(i => i.id);
            selectedObservers = selectedObservers.filter(i => observersNames.indexOf(i) > -1);
        }
        const stateChange = {
            activeCompanyId: companyId,
            units,
            states,
            eventTypes,
            eventTypeBs,
            eventTypeCs,
            partners,
            creators,
            handlers,
            observers,
            eventSettingsActions: this.getEventSettingsActions(eventPageData),
            userPrints: eventPageData.userPrints,
            printableFields: eventPageData.printableFields,
            selectedUnitIds,
            selectedStateIds,
            selectedEventTypeIds,
            selectedEventTypeBIds,
            selectedEventTypeCIds,
            selectedPartnerCompanyIds,
            selectedCreateUserCodes,
            selectedHandlerUserCodes,
            selectedObservers
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
    };

    // #region Report Filter
    getActiveReport = (): IReportItem => {
        const state = this.state;
        return state.activeReportId
            ? state.reports.find(i => i.id === state.activeReportId)
            : state.savedReports.find(i => i.id === state.activeSavedReportId);
    };

    onRecordReportFilterDialogOk = (filterState: IEventPageFilterState, parameters: ITaskDataRow): ISaveReportFilters => {
        const state = this.state;
        const reports = state.reports.slice(0);
        const savedReports = state.savedReports.slice(0);
        const index = state.activeReportId
            ? reports.findIndex(i => i.id === state.activeReportId)
            : savedReports.findIndex(i => i.id === state.activeSavedReportId);
        if (index < 0) return;
        let reportFilter = null;
        if (state.activeReportId) {
            const report = new ReportItem(reports[index]);
            report.taskDataRow = parameters;
            reportFilter = SaveReportDialog.getReportFilter(report);
            reports[index] = report;
        } else {
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.taskDataRow = parameters;
            savedReport.reportFilter = SaveReportDialog.getReportFilter(savedReport);
            reportFilter = savedReport.reportFilter;
            savedReports[index] = savedReport;
        }
        const stateChange = {
            ...filterState,
            reports,
            savedReports,
        };
        const newState = { ...state, ...stateChange };
        this.setState({
            ...stateChange,
            listFilterIsSet: this.getListFilterIsSet(newState)
        });
        return {
            generalFilter: getEventGeneralFilterFromFilterState(newState),
            reportFilter,
            showInFrontPage: false
        };
    };
    // #endregion Report Filter

    // #region Report Save
    handleSetSortData = (sortColumn: string, sortOrderIsAsc: boolean) => {
        const state = this.state;
        if (state.activeReportId) {
            const reports = state.reports.slice(0);
            const index = reports.findIndex(i => i.id === state.activeReportId);
            if (index < 0) return;
            const report = new ReportItem(reports[index]);
            report.sortColumn = sortColumn;
            report.sortOrderIsAsc = sortOrderIsAsc;
            reports[index] = report;
            const newState = { ...this.state, reports };
            this.setState({
                reports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        } else if (state.activeSavedReportId) {
            const savedReports = state.savedReports.slice(0);
            const index = savedReports.findIndex(i => i.id === state.activeSavedReportId);
            if (index < 0) return;
            const savedReport = new ReportItem(savedReports[index]);
            savedReport.sortColumn = sortColumn;
            savedReport.sortOrderIsAsc = sortOrderIsAsc;
            savedReports[index] = savedReport;
            const newState = { ...this.state, savedReports };
            this.setState({
                savedReports,
                listFilterIsSet: this.getListFilterIsSet(newState)
            });
        }
    };

    updateReportsAfterSave = (orgReportId: string, savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        if (!savedReport) return;
        const state = this.state;
        const savedReports = state.savedReports.filter(i => i.id !== orgReportId || i.reportSharingType !== reportSharingType);
        const report = state.reports.find(i => i.id === savedReport.reportId);
        if (!report) return;
        const newReport = ReportItem.createReportItemFromSavedReport(report, savedReport, reportSharingType);
        savedReports.push(newReport);
        ReportItem.sortReportItems(savedReports);
        this.setState({
            showReportSaveDialog: false,
            savedReports,
            activeReportId: "",
            activeSavedReportId: savedReport.id,
            reportFilterReport: newReport
        });
    };

    handleSaveAsReportsModifiedReport = async (saveAs: boolean, onGetReportSaveFilters: () => ISaveReportFilters) => {
        const state = this.state;
        const report = this.getActiveReport();
        if (!report) return;
        if (!saveAs) {
            const savedReport = await SaveReportDialog.saveReportToDb(report, getEventGeneralFilterFromFilterState(state), state.activeCompanyId, ApplicationPermissionType.Event);
            this.updateReportsAfterSave(report.id, savedReport, report.reportSharingType);
        } else {
            this.setState({
                showReportSaveDialog: true,
                reportSaveDialogReport: report,
                reportSaveDialogReservedNames: state.savedReports.map(i => i.id).concat(state.reports.map(i => i.title)),
                reportSaveDialogGeneralFilter: getEventGeneralFilterFromFilterState(state),
                reportSaveDialogOnGetReportSaveFilters: onGetReportSaveFilters
            });
        }
    };

    handleReportSaveDialogOk = (savedReport: ISavedReport, reportSharingType: ReportSharingType) => {
        this.updateReportsAfterSave("", savedReport, reportSharingType);
    };

    handleReportSaveDialogCancel = () => {
        this.setState({
            showReportSaveDialog: false
        });
    };
    // #endregion Report Save

    // #region Dashboard
    handleToggleShowDashboardNavPanel = () => {
        this.setState({ showDashBoardNavPanel: !this.state.showDashBoardNavPanel });
    };

    handleUpdateDashBoardPanels = async (panels: IPagePanel[]) => {
        this.setState({
            dashBoardPanels: panels
        });
    };

    getSavedChartPanels = (panels: IPagePanel[]): ISavedChartPanel[] => {
        return panels.filter(i => i.panelType === ContentPagePanelType.Chart).map(i => i as SavedChartPanel);
    };

    handleSaveDashBoardPanels = async (panels: IPagePanel[]) => {
        const pagePanels = panels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        await eventService.saveEventPanels(pagePanels);
        const chartPanels = this.getSavedChartPanels(panels);
        await eventService.saveEventChartPanels(chartPanels);
        this.setState({
            dashBoardPanels: panels
        });
    };

    handleDashboardSavedFilterClick = (filterId: string) => {
        this.handleChangeActiveSavedFilter(filterId);
        this.setState({
            activeViewType: EventPageViewType.Events
        });
    };

    handleDashboardFilterClick = (filterId: string) => {
        this.handleChangeActiveFilter(filterId);
        this.setState({
            activeViewType: EventPageViewType.Events
        });
    };

    handleDashboardSavedReportClick = (reportId: string) => {
        this.handleChangeActiveSavedReport(reportId);
        this.setState({
            activeViewType: EventPageViewType.Reports
        });
    };

    handleDashboardReportClick = (reportId: string) => {
        this.handleChangeActiveReport(reportId);
        this.setState({
            activeViewType: EventPageViewType.Reports
        });
    };

    handleShowChartPanelPropertiesDialog = (panelId: string) => {
        if (!panelId) return;
        const state = this.state;
        const chartPanels = this.getSavedChartPanels(state.dashBoardPanels);
        const chartPanel = chartPanels.find(i => i.id === panelId);
        if (!chartPanel) return;
        const chartItem = state.reportChartItems.find(i => i.reportName === chartPanel.reportId);
        if (!chartItem) return;
        this.setState({
            showDashBoardChartPanel: true,
            reportFilterReport: ReportItem.createReportItem(chartPanel.id, "", ReportType.Pdf, chartItem.taskType),
            dashBoardChartPanelFilter: getFilterStatePropsFromEventGeneralFilter(chartPanel.generalFilter),
            dashBoardChartPanelVisible: chartPanel.visible,
            dashBoardChartPanelPanelSize: chartPanel.size,
            dashBoardChartPanelChartItems: state.reportChartItems,
            dashBoardChartPanelChartPanel: chartPanel,
            dashBoardChartPanelReservedChartNames: chartPanels.filter(i => i.id !== panelId).map(i => i.reportTitle)
        });
    };

    handleAddChartPanel = (sharedPanel: ISharedPanel | null) => {
        const state = this.state;
        if (state.reportChartItems.length < 1) return;
        const chartPanels = this.getSavedChartPanels(state.dashBoardPanels);
        const chartItem = sharedPanel == null
            ? state.reportChartItems[0]
            : state.reportChartItems.find(i => i.reportName === sharedPanel.reportId);
        const position = Base.maxVal(state.dashBoardPanels.map(i => i.position), -1) + 1;
        const chartPanel = sharedPanel == null
            ? SavedChartPanel.CreateSavedChartPanel(chartItem, position, ApplicationPermissionType.Event)
            : SavedChartPanel.CreateSavedChartPanelBySharedPanel(sharedPanel, position, ApplicationPermissionType.Event);
        chartPanel.id = "";
        chartPanel.visible = true;
        if (sharedPanel == null) {
            chartPanel.reportTitle = Translations.NewPanel;
            chartPanel.generalFilter = { dynamicTimeFilterId: 1 }; //Default time filter is last 30 days
        }
        this.setState({
            showDashBoardChartPanel: true,
            reportFilterReport: ReportItem.createReportItem(chartPanel.id, "", ReportType.Pdf, chartItem.taskType),
            dashBoardChartPanelFilter: getFilterStatePropsFromEventGeneralFilter(chartPanel.generalFilter),
            dashBoardChartPanelVisible: chartPanel.visible,
            dashBoardChartPanelPanelSize: chartPanel.size,
            dashBoardChartPanelChartItems: state.reportChartItems,
            dashBoardChartPanelChartPanel: chartPanel,
            dashBoardChartPanelReservedChartNames: chartPanels.map(i => i.reportTitle)
        });
    };
    
    handleChartPanelSaved = (chartPanel: ISavedChartPanel) => {
        const state = this.state;
        if (!chartPanel || !state.dashBoardChartPanelChartPanel) return;
        const pagePanels = state.dashBoardPanels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        const chartPanels = this.getSavedChartPanels(state.dashBoardPanels).filter(i => i.id !== chartPanel.id && i.id !== state.dashBoardChartPanelChartPanel.id);
        chartPanels.push(chartPanel);
        this.setState({
            showDashBoardChartPanel: false,
            dashBoardPanels: PagePanel.sortPagePanels(pagePanels.concat(chartPanels))
        });
    };

    handleChartPanelRemoved = (chartPanelId: string) => {
        if (!chartPanelId) return;
        const state = this.state;
        const pagePanels = state.dashBoardPanels.filter(i => i.panelType !== ContentPagePanelType.Chart);
        const chartPanels = this.getSavedChartPanels(state.dashBoardPanels).filter(i => i.id !== chartPanelId);
        this.setState({
            showDashBoardChartPanel: false,
            dashBoardPanels: PagePanel.sortPagePanels(pagePanels.concat(chartPanels))
        });
    };
    
    handleChartPanelReportFilterDialogCancel = () => {
        this.setState({
            showDashBoardChartPanel: false
        });
    };

    static getDefaultListFilter = (toDoItem: IFrontToDoItem, userCode: string): TDefaultListFilter => {
        if (!toDoItem) return null;
        if (toDoItem.id === "EventUserUnapprovedCount") {
            return {
                filterId: Translations.Events,
                generalFilter: {
                    states: ["1"]
                }
            };
        }
        if (toDoItem.id === "EventOpenUserCreatedCount") {
            return {
                filterId: Translations.Events,
                generalFilter: {
                    states: ["5"],
                    createUserCodes: [userCode]
                }
            };
        }
        return null;
    };
    
    handleToItemClick = (toDoItem: IFrontToDoItem) => {
        const defaultListFilter = EventPage.getDefaultListFilter(toDoItem, this.props.appState.state.code);
        this.handleSetActiveViewType(EventPageViewType.Events, defaultListFilter?.filterId, defaultListFilter?.generalFilter);
    };
    // #endregion Dashboard

    render() {
        const props = this.props;
        const state = this.state;
        const sessionState = props.appState.state;
        const companies = props.eventPage ? props.eventPage.companies : [];
        const dashboardViewIsActive = state.activeViewType === EventPageViewType.Dashboard;
        const eventsViewIsActive = state.activeViewType === EventPageViewType.Events;
        const reportsViewIsActive = state.activeViewType === EventPageViewType.Reports;
        const settingsVisible = state.eventSettingsActions?.length > 0;
        return (
            <PageContainer>
                <NavigationMenu
                    appState={props.appState}
                    activeMenuItem={HeaderMenuItem.Events}
                    companies={companies}
                    activeCompanyId={state.activeCompanyId}
                    onChangeActiveCompany={this.handleChangeActiveCompanyId}
                />
                <PageContent>
                    <PageTopBar justifyContent="space-between">
                        <PageTabs
                            activeTabId={state.activeViewType}
                            tabs={[
                                { id: EventPageViewType.Dashboard, title: Translations.FrontPage },
                                { id: EventPageViewType.Events, title: Translations.Events },
                                { id: EventPageViewType.Reports, title: Translations.Reports }
                            ]}
                            changeTab={this.handleSetActiveViewType}
                        />
                        <UserMenu
                            appState={props.appState}
                            onLogout={props.onLogout}
                            onSetCulture={props.onSetCulture}
                            onRefreshSessionState={props.onRefreshSessionState}
                        />
                    </PageTopBar>
                    {!dashboardViewIsActive &&
                        <PageListAndReportsContainer>
                            {eventsViewIsActive &&
                                <EventList
                                    savedFilter={state.activeSavedFilterId ? state.savedFilters.find(i => i.id === state.activeSavedFilterId) : null}
                                    sessionState={sessionState}
                                    dataId={state.dataId.toString(10)}
                                    addRecord={state.listAddRecord}
                                    listFilterIsSet={state.listFilterIsSet}
                                    units={state.units}
                                    selectedStartDate={state.selectedStartDate}
                                    selectedEndDate={state.selectedEndDate}
                                    selectedUnitIds={state.selectedUnitIds}
                                    selectedStateIds={state.selectedStateIds}
                                    selectedUrgencyClassIds={state.selectedUrgencyClassIds}
                                    selectedEventTypeIds={state.selectedEventTypeIds}
                                    selectedEventTypeBIds={state.selectedEventTypeBIds}
                                    selectedEventTypeCIds={state.selectedEventTypeCIds}
                                    selectedPartnerCompanyIds={state.selectedPartnerCompanyIds}
                                    selectedCreateUserCodes={state.selectedCreateUserCodes}
                                    selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                    selectedObservers={state.selectedObservers}
                                    selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                                    companyId={state.activeCompanyId}
                                    sortColumn={state.sortColumn}
                                    sortOrderIsAsc={state.sortOrderIsAsc}
                                    userPrints={state.userPrints}
                                    printableFields={state.printableFields}
                                    reportTabs={(
                                        <FilterTabs
                                            items={state.savedFilters}
                                            standardFilters={state.filters}
                                            selectedId={this.state.activeFilterId}
                                            selectedSavedId={this.state.activeSavedFilterId}
                                            onSetActiveItem={this.handleChangeActiveSavedFilter}
                                            onSetActiveStandardItem={this.handleChangeActiveFilter}
                                        />
                                    )}
                                    showDocumentPreview={state.showDocumentPreview}
                                    urgencyClasses={state.urgencyClasses}
                                    onSetSortData={this.handleFilterSortData}
                                    onLoadPageData={() => this.handleRefreshPageData(state.activeCompanyId)}
                                    onUserPrintsModified={this.handleUserPrintsModified}
                                    onOpenFiltersDialog={this.handleOpenEventFilterDialog}
                                    onChangeShowDocumentPreview={this.handleShowDetailsPanel}
                                />
                            }
                            {reportsViewIsActive &&
                                <PageReportsContainer>
                                    <EventPageReport
                                        companyId={state.activeCompanyId}
                                        reports={state.activeReportId ? state.reports : state.savedReports}
                                        reportId={state.activeReportId ? state.activeReportId : state.activeSavedReportId}
                                        selectedStartDate={state.selectedStartDate}
                                        selectedEndDate={state.selectedEndDate}
                                        selectedUnitIds={state.selectedUnitIds}
                                        selectedStateIds={state.selectedStateIds}
                                        selectedUrgencyClassIds={state.selectedUrgencyClassIds}
                                        selectedEventTypeIds={state.selectedEventTypeIds}
                                        selectedEventTypeBIds={state.selectedEventTypeBIds}
                                        selectedEventTypeCIds={state.selectedEventTypeCIds}
                                        selectedPartnerCompanyIds={state.selectedPartnerCompanyIds}
                                        selectedCreateUserCodes={state.selectedCreateUserCodes}
                                        selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                        selectedObservers={state.selectedObservers}
                                        selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                                        onSetSortData={this.handleSetSortData}
                                    />
                                    <ReportSettings
                                        filters={
                                            <EventPageReportFilterPanel
                                                report={state.reportFilterReport}
                                                units={state.units}
                                                states={state.states}
                                                urgencyClasses={state.urgencyClasses}
                                                eventTypes={state.eventTypes}
                                                eventTypeBs={state.eventTypeBs}
                                                eventTypeCs={state.eventTypeCs}
                                                partners={state.partners}
                                                creators={state.creators}
                                                handlers={state.handlers}
                                                observers={state.observers}
                                                dynamicTimeFilters={state.dynamicTimeFilters}
                                                selectedStartDate={state.selectedStartDate}
                                                selectedEndDate={state.selectedEndDate}
                                                selectedUnitIds={state.selectedUnitIds}
                                                selectedStateIds={state.selectedStateIds}
                                                selectedUrgencyClassIds={state.selectedUrgencyClassIds}
                                                selectedEventTypeIds={state.selectedEventTypeIds}
                                                selectedEventTypeBIds={state.selectedEventTypeBIds}
                                                selectedEventTypeCIds={state.selectedEventTypeCIds}
                                                selectedPartnerCompanyIds={state.selectedPartnerCompanyIds}
                                                selectedCreateUserCodes={state.selectedCreateUserCodes}
                                                selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                                                selectedObservers={state.selectedObservers}
                                                selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                onSaveReport={this.handleSaveAsReportsModifiedReport}
                                                onRemoveReport={this.handleRemoveSavedReport}
                                                onOk={this.onRecordReportFilterDialogOk}
                                                onCancel={() => {}}
                                            />
                                        }
                                        reports={
                                            <PageNavMenuReportList
                                                canRemoveSharedReports={sessionState.isSuperAdmin}
                                                items={state.savedReports}
                                                standardReports={state.reports}
                                                activeItemId={state.activeSavedReportId}
                                                activeStandardItemId={state.activeReportId}
                                                showingSavedReports={true}
                                                title={Translations.Report}
                                                onSetActiveItem={this.handleChangeActiveSavedReport}
                                                onSetActiveStandardItem={this.handleChangeActiveReport}
                                            />
                                        }
                                    />
                                </PageReportsContainer>
                            }
                        </PageListAndReportsContainer>
                    }
                    {dashboardViewIsActive &&
                        <DashboardPanelList
                            companyId={state.activeCompanyId}
                            applicationPermissionType={ApplicationPermissionType.Event}
                            canSharePanels={sessionState.isCompanyAdmin}
                            hidden={!state.showDashBoardNavPanel}
                            panels={state.dashBoardPanels}
                            onUpdatePanels={this.handleUpdateDashBoardPanels}
                            onSavePanels={this.handleSaveDashBoardPanels}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                            onShowChartPanelProperties={this.handleShowChartPanelPropertiesDialog}
                            onAddChart={this.handleAddChartPanel}
                            onGetSharedPanels={eventService.getSharedPanels}
                            onSaveSharedPanel={eventService.saveSharedPanel}
                            onGetUserGroupSelectListItems={eventService.getSharePanelUserGroupListItems}
                        />
                    }
                    {dashboardViewIsActive &&
                        <PageDashboard
                            title={Translations.EventsDashboard}
                            settingsVisible={settingsVisible}
                            panels={state.dashBoardPanels}
                            companyId={state.activeCompanyId}
                            filters={state.filters}
                            savedFilters={state.savedFilters}
                            loadingReports={state.loadingReports}
                            reports={state.reports}
                            savedReports={state.savedReports}
                            chartItems={state.reportChartItems}
                            dashboardChart={EventPageDashboardChart}
                            addButton={<AddButton variant="contained" onClick={this.handleAddEvent} sx={{ marginRight: "24px" }}>{Translations.AddEvent}</AddButton>}
                            onSavedFilterClick={this.handleDashboardSavedFilterClick}
                            onFilterClick={this.handleDashboardFilterClick}
                            onSavedReportClick={this.handleDashboardSavedReportClick}
                            onReportClick={this.handleDashboardReportClick}
                            onShowChartPanelPropertiesDialog={this.handleShowChartPanelPropertiesDialog}
                            onToggleMenuPanel={this.handleToggleShowDashboardNavPanel}
                            onToggleSettingsDialog={() => this.handleOpenSettings(false)}
                            onGetToDoItems={eventService.getEventToDoItems}
                            onStatisticsClick={this.handleToItemClick}
                        />
                    }
                </PageContent>
                <EventPageFilterDrawer
                    open={state.showEventFilterDialog}
                    filter={state.eventFilterDialogFilter}
                    units={state.units}
                    states={state.states}
                    urgencyClasses={state.urgencyClasses}
                    eventTypes={state.eventTypes}
                    eventTypeBs={state.eventTypeBs}
                    eventTypeCs={state.eventTypeCs}
                    partners={state.partners}
                    creators={state.creators}
                    handlers={state.handlers}
                    observers={state.observers}
                    dynamicTimeFilters={state.dynamicTimeFilters}
                    selectedStartDate={state.selectedStartDate}
                    selectedEndDate={state.selectedEndDate}
                    selectedUnitIds={state.selectedUnitIds}
                    selectedStateIds={state.selectedStateIds}
                    selectedUrgencyClassIds={state.selectedUrgencyClassIds}
                    selectedEventTypeIds={state.selectedEventTypeIds}
                    selectedEventTypeBIds={state.selectedEventTypeBIds}
                    selectedEventTypeCIds={state.selectedEventTypeCIds}
                    selectedPartnerCompanyIds={state.selectedPartnerCompanyIds}
                    selectedCreateUserCodes={state.selectedCreateUserCodes}
                    selectedHandlerUserCodes={state.selectedHandlerUserCodes}
                    selectedObservers={state.selectedObservers}
                    selectedDynamicTimeFilterId={state.selectedDynamicTimeFilterId}
                    canRemoveSharedFilters={sessionState.isCompanyAdmin}
                    onSaveFilter={this.handleSaveListFilter}
                    onRemoveFilter={this.handleRemoveSavedFilter}
                    onOk={this.onEventFilterDialogOk}
                    onCancel={this.onEventFilterDialogCancel}
                />
                {state.showListFilterSaveDialog &&
                    <ListFilterSaveDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Event}
                        listFilter={state.listFilterSaveDialogFilter}
                        generalFilter={state.listFilterSaveDialogGeneralFilter}
                        sortColumn={state.sortColumn}
                        sortOrderIsAsc={state.sortOrderIsAsc}
                        reservedNames={state.listFilterSaveDialogReservedNames}
                        onGetGeneralFilter={state.listFilterSaveDialogOnGetGeneralFilter}
                        onOk={this.handleSaveListFilterDialogOk}
                        onCancel={this.handleSaveListFilterDialogCancel}
                    />
                }
                {state.showDashBoardChartPanel &&
                    <EventPageReportFilterPanel
                        chartPanelDrawerMode={true}
                        report={state.reportFilterReport}
                        units={state.units}
                        chartPanel={state.dashBoardChartPanelChartPanel}
                        chartItems={state.dashBoardChartPanelChartItems}
                        reservedChartNames={state.dashBoardChartPanelReservedChartNames}
                        states={state.states}
                        urgencyClasses={state.urgencyClasses}
                        eventTypes={state.eventTypes}
                        eventTypeBs={state.eventTypeBs}
                        eventTypeCs={state.eventTypeCs}
                        partners={state.partners}
                        creators={state.creators}
                        handlers={state.handlers}
                        observers={state.observers}
                        dynamicTimeFilters={state.dynamicTimeFilters}
                        selectedStartDate={state.dashBoardChartPanelFilter.selectedStartDate}
                        selectedEndDate={state.dashBoardChartPanelFilter.selectedEndDate}
                        selectedUnitIds={state.dashBoardChartPanelFilter.selectedUnitIds}
                        selectedStateIds={state.dashBoardChartPanelFilter.selectedStateIds}
                        selectedUrgencyClassIds={state.selectedUrgencyClassIds}
                        selectedEventTypeIds={state.dashBoardChartPanelFilter.selectedEventTypeIds}
                        selectedEventTypeBIds={state.dashBoardChartPanelFilter.selectedEventTypeBIds}
                        selectedEventTypeCIds={state.dashBoardChartPanelFilter.selectedEventTypeCIds}
                        selectedPartnerCompanyIds={state.dashBoardChartPanelFilter.selectedPartnerCompanyIds}
                        selectedCreateUserCodes={state.dashBoardChartPanelFilter.selectedCreateUserCodes}
                        selectedHandlerUserCodes={state.dashBoardChartPanelFilter.selectedHandlerUserCodes}
                        selectedObservers={state.dashBoardChartPanelFilter.selectedObservers}
                        selectedDynamicTimeFilterId={state.dashBoardChartPanelFilter.selectedDynamicTimeFilterId}
                        canRemoveSharedReports={true}
                        panelSize={state.dashBoardChartPanelPanelSize}
                        panelVisible={state.dashBoardChartPanelVisible}
                        onSaveReport={null}
                        onRemoveReport={null}
                        onOk={null}
                        onChartPanelSaved={this.handleChartPanelSaved}
                        onChartPanelRemoved={this.handleChartPanelRemoved}
                        onCancel={this.handleChartPanelReportFilterDialogCancel}
                    />
                }
                {state.showReportSaveDialog &&
                    <SaveReportDialog
                        sessionState={sessionState}
                        companyId={state.activeCompanyId}
                        applicationPermissionType={ApplicationPermissionType.Event}
                        report={state.reportSaveDialogReport}
                        generalFilter={state.reportSaveDialogGeneralFilter}
                        reservedNames={state.reportSaveDialogReservedNames}
                        onGetReportSaveFilters={state.reportSaveDialogOnGetReportSaveFilters}
                        onOk={this.handleReportSaveDialogOk}
                        onCancel={this.handleReportSaveDialogCancel}
                    />
                }
                {state.showSettingsDialog &&
                    <EventSettingsDialog
                        companyId={state.settingsDialogCompanyId}
                        onClose={this.handleSettingsDialogOk}
                        settingsActions={state.eventSettingsActions}
                        sessionState={sessionState}
                    />
                }
            </PageContainer>
        );
    }
}